import { motion } from 'framer-motion';
import { decimalFormat } from 'src/shared/utils/number-utils';

export const ConvElectricPvSLoad = (props: { data: any; color: any }) => {
  let pvInsPT = 0;
  let gridInsPT = 0;
  let pvCsq = 0;
  let gridCsq = 0;

  props.data.forEach(res => {
    if (res.readerType === 1) {
      pvInsPT += res.insPT;
      if (res.csq !== 0) {
        pvCsq = res.csq;
      }
    } else {
      gridInsPT += res.insPT;
      if (res.csq !== 0) {
        gridCsq = res.csq;
      }
    }
  });

  const enablePvAnimation = pvCsq > 0;
  const enableGridAnimation = gridCsq > 0;
  const pvPower = enablePvAnimation && pvInsPT > 0 ? pvInsPT : 0;
  const pylonPower = enableGridAnimation ? gridInsPT : 0;
  const housePower = (enablePvAnimation ? pvPower : 0) + (enableGridAnimation ? pylonPower : 0);

  const AnimationPv = ({ variant }) => (
    <motion.g variants={variant} initial="initial" animate="animate" transition={{ duration: 0.5, repeat: Infinity, ease: 'linear' }}>
      <g style={{}} fillRule="evenodd" strokeWidth="0" transform="matrix(-0.447037, 0, 0, 0.138405, 333.228882, 168.648911)">
        {/* <title>solarBolt</title> */}
        <rect
          height="45.222"
          style={{ fill: '#f5f5f5', stroke: 'url(#z)', strokeWidth: '4.04233px' }}
          width="573.773"
          transform="matrix(-1, 0, 0, 1, 0, 0)"
          x="-336.8"
          y="226.374"
        />
        <path
          style={{ fill: props.color }}
          d="M 346.461 229.983 L 322.082 245.908 L 335.223 246.202 L 314.373 259.488 L 323.205 259.594 L 308.572 269.96 L 343.93 257.316 L 330.768 257.405 L 357.41 243.764 L 342.999 243.741 L 366.677 229.558 L 346.462 229.983 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 261.803 229.706 L 237.418 245.634 L 250.562 245.924 L 229.716 259.216 L 238.543 259.318 L 223.908 269.683 L 259.269 257.043 L 246.107 257.13 L 272.751 243.49 L 258.336 243.469 L 282.017 229.286 L 261.803 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 177.136 229.706 L 152.757 245.631 L 165.898 245.925 L 145.048 259.211 L 153.88 259.317 L 139.247 269.683 L 174.605 257.039 L 161.443 257.128 L 188.085 243.487 L 173.674 243.464 L 197.352 229.281 L 177.137 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 92.474 229.706 L 68.095 245.631 L 81.236 245.925 L 60.386 259.211 L 69.218 259.317 L 54.585 269.683 L 89.943 257.039 L 76.781 257.128 L 103.423 243.487 L 89.012 243.464 L 112.69 229.281 L 92.475 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 7.812 229.706 L -16.567 245.631 L -3.426 245.925 L -24.276 259.211 L -15.444 259.317 L -30.077 269.683 L 5.281 257.039 L -7.881 257.128 L 18.761 243.487 L 4.35 243.464 L 28.028 229.281 L 7.813 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M -76.851 229.706 L -101.227 245.634 L -88.083 245.924 L -108.938 259.216 L -100.102 259.318 L -114.737 269.683 L -79.376 257.043 L -92.538 257.13 L -65.902 243.49 L -80.309 243.469 L -56.637 229.286 L -76.851 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M -161.513 229.706 L -185.892 245.631 L -172.751 245.925 L -193.601 259.211 L -184.769 259.317 L -199.402 269.683 L -164.044 257.039 L -177.206 257.128 L -150.564 243.487 L -164.975 243.464 L -141.297 229.281 L -161.512 229.706 Z"
        />
      </g>
    </motion.g>
  );

  const AnimationPylon = ({ variant }) => (
    <motion.g variants={variant} initial="initial" animate="animate" transition={{ duration: 0.5, repeat: Infinity, ease: 'linear' }}>
      <g style={{}} fillRule="evenodd" strokeWidth="0" transform="matrix(0.165531, 0, 0, 0.085854, 341.646606, 20.5889)">
        <rect
          height="45.222"
          style={{ fill: '#f5f5f5', stroke: 'url(#z)', strokeWidth: '4.04233px' }}
          width="573.773"
          transform="matrix(-1, 0, 0, 1, 0, 0)"
          x="-336.8"
          y="226.374"
        />
        <path
          style={{ fill: props.color }}
          d="M 261.803 229.706 L 237.418 245.634 L 250.562 245.924 L 229.716 259.216 L 238.543 259.318 L 223.908 269.683 L 259.269 257.043 L 246.107 257.13 L 272.751 243.49 L 258.336 243.469 L 282.017 229.286 L 261.803 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 177.136 229.706 L 152.757 245.631 L 165.898 245.925 L 145.048 259.211 L 153.88 259.317 L 139.247 269.683 L 174.605 257.039 L 161.443 257.128 L 188.085 243.487 L 173.674 243.464 L 197.352 229.281 L 177.137 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 92.474 229.706 L 68.095 245.631 L 81.236 245.925 L 60.386 259.211 L 69.218 259.317 L 54.585 269.683 L 89.943 257.039 L 76.781 257.128 L 103.423 243.487 L 89.012 243.464 L 112.69 229.281 L 92.475 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 7.812 229.706 L -16.567 245.631 L -3.426 245.925 L -24.276 259.211 L -15.444 259.317 L -30.077 269.683 L 5.281 257.039 L -7.881 257.128 L 18.761 243.487 L 4.35 243.464 L 28.028 229.281 L 7.813 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M -76.851 229.706 L -101.227 245.634 L -88.083 245.924 L -108.938 259.216 L -100.102 259.318 L -114.737 269.683 L -79.376 257.043 L -92.538 257.13 L -65.902 243.49 L -80.309 243.469 L -56.637 229.286 L -76.851 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M -161.513 229.706 L -185.892 245.631 L -172.751 245.925 L -193.601 259.211 L -184.769 259.317 L -199.402 269.683 L -164.044 257.039 L -177.206 257.128 L -150.564 243.487 L -164.975 243.464 L -141.297 229.281 L -161.512 229.706 Z"
        />
      </g>
    </motion.g>
  );

  const AnimationHouse = ({ variant }) => (
    <motion.g variants={variant} initial="initial" animate="animate" transition={{ duration: 0.5, repeat: Infinity, ease: 'linear' }}>
      <g style={{}} fillRule="evenodd" strokeWidth="0" transform="matrix(0, -0.146452, -0.210032, 0, 300.220001, 331.488159)">
        <rect
          height="45.222"
          style={{ fill: 'rgb(255, 255, 255)', stroke: 'rgb(0, 0, 0)', strokeWidth: '4.04233px' }}
          width="573.773"
          transform="matrix(-1, 0, 0, 1, 0, 0)"
          x="-336.8"
          y="226.374"
        />
        <path
          style={{ fill: props.color }}
          d="M 346.461 229.983 L 322.082 245.908 L 335.223 246.202 L 314.373 259.488 L 323.205 259.594 L 308.572 269.96 L 343.93 257.316 L 330.768 257.405 L 357.41 243.764 L 342.999 243.741 L 366.677 229.558 L 346.462 229.983 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 261.803 229.706 L 237.418 245.634 L 250.562 245.924 L 229.716 259.216 L 238.543 259.318 L 223.908 269.683 L 259.269 257.043 L 246.107 257.13 L 272.751 243.49 L 258.336 243.469 L 282.017 229.286 L 261.803 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 177.136 229.706 L 152.757 245.631 L 165.898 245.925 L 145.048 259.211 L 153.88 259.317 L 139.247 269.683 L 174.605 257.039 L 161.443 257.128 L 188.085 243.487 L 173.674 243.464 L 197.352 229.281 L 177.137 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 92.474 229.706 L 68.095 245.631 L 81.236 245.925 L 60.386 259.211 L 69.218 259.317 L 54.585 269.683 L 89.943 257.039 L 76.781 257.128 L 103.423 243.487 L 89.012 243.464 L 112.69 229.281 L 92.475 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M 7.812 229.706 L -16.567 245.631 L -3.426 245.925 L -24.276 259.211 L -15.444 259.317 L -30.077 269.683 L 5.281 257.039 L -7.881 257.128 L 18.761 243.487 L 4.35 243.464 L 28.028 229.281 L 7.813 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M -76.851 229.706 L -101.227 245.634 L -88.083 245.924 L -108.938 259.216 L -100.102 259.318 L -114.737 269.683 L -79.376 257.043 L -92.538 257.13 L -65.902 243.49 L -80.309 243.469 L -56.637 229.286 L -76.851 229.706 Z"
        />
        <path
          style={{ fill: props.color }}
          d="M -161.513 229.706 L -185.892 245.631 L -172.751 245.925 L -193.601 259.211 L -184.769 259.317 L -199.402 269.683 L -164.044 257.039 L -177.206 257.128 L -150.564 243.487 L -164.975 243.464 L -141.297 229.281 L -161.512 229.706 Z"
        />
      </g>
    </motion.g>
  );

  return (
    <svg viewBox="0 0 300 145" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id="af"
          gradientTransform="matrix(-0.120688, 0.025874, 0.017427, 0.179322, 93.086418, 119.687782)"
          gradientUnits="userSpaceOnUse"
          x2="0"
          y1="595.29"
          y2="165.51"
        >
          <stop offset="0.1538" stopColor="#ffed00" />
          <stop offset="0.2173" stopColor="#fe0" />
          <stop offset="0.3229" stopColor="#ffef2a" />
          <stop offset="0.4575" stopColor="#fff268" />
          <stop offset="0.616" stopColor="#fff6a4" />
          <stop offset="0.7925" stopColor="#fffcdf" />
          <stop offset="0.8956" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="ae"
          gradientTransform="matrix(0.232674, 0, 0, 0.181188, 88.469698, 117.966931)"
          gradientUnits="userSpaceOnUse"
          x2="0"
          y1="669.77"
          y2="490.45"
        >
          <stop offset="0" stopColor="#9b9b9a" />
          <stop offset="0.9505" stopColor="#7e7e7d" />
        </linearGradient>
        <linearGradient
          id="z"
          gradientTransform="matrix(0.232674, 0, 0, 0.181188, 88.469698, 117.966931)"
          gradientUnits="userSpaceOnUse"
          x2="0"
          y1="589.39"
          y2="561.08"
        >
          <stop offset="0" stopColor="#474746" />
          <stop offset="0.9505" stopColor="#727271" />
        </linearGradient>
        <linearGradient
          id="t"
          gradientTransform="matrix(0.232674, 0, 0, 0.181188, 88.469698, 117.966931)"
          gradientUnits="userSpaceOnUse"
          x1="487.65"
          x2="97.646"
          y1="559.02"
          y2="410.02"
        >
          <stop offset="0" stopColor="#878787" />
          <stop offset="0.2396" stopColor="#8f8f8e" />
          <stop offset="0.9066" stopColor="#a1a1a1" />
        </linearGradient>
        <linearGradient
          id="b"
          gradientTransform="matrix(0.000002, 0, 0, 0, 90.294291, 140.34657)"
          gradientUnits="userSpaceOnUse"
          x2="0"
          y1="411.66"
          y2="387.46"
        >
          <stop offset="0" stopColor="#9fc8de" />
          <stop offset="1" stopColor="#3abff0" />
        </linearGradient>
        <linearGradient
          id="gradient-1"
          gradientTransform="matrix(0.44705, 0, 0, 0.518225, 116.324708, 323.948873)"
          gradientUnits="userSpaceOnUse"
          x1="349.99"
          x2="429.83"
          y1="113.63"
          y2="193.63"
        >
          <stop offset="0" stopColor="#0197fd" />
          <stop offset="1" stopColor="#4e9a06" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="gradient-0" gradientUnits="userSpaceOnUse" x1="298.933" x2="298.933" y1="31.675" y2="59.232">
          <stop style={{ stopColor: 'rgb(255, 255, 255)' }} offset="0" />
          <stop style={{ stopColor: 'rgb(250, 197, 197)' }} offset="1" />
        </linearGradient>
        <linearGradient id="gradient-3" gradientUnits="userSpaceOnUse" x1="220.912" x2="220.912" y1="31.675" y2="59.232">
          <stop style={{ stopColor: 'rgb(252, 252, 252)' }} offset="0" />
          <stop style={{ stopColor: 'rgb(199, 247, 191)' }} offset="1" />
        </linearGradient>
        <linearGradient
          id="gradient-2"
          gradientTransform="matrix(0.999861, -0.01588, 0.00381, 0.218075, -0.022611, 16.166541)"
          gradientUnits="userSpaceOnUse"
          x1="259.898"
          x2="259.898"
          y1="15.397"
          y2="90.051"
        >
          <stop style={{ stopColor: 'rgba(224, 222, 222, 0.973)' }} offset="0" />
          <stop style={{ stopColor: props.color }} offset="1" />
        </linearGradient>
        <radialGradient
          id="ai"
          cx="1528.5"
          cy="17073"
          gradientTransform="matrix(0.202985, 0, 0, 0.012482, -156.523573, 26.745566)"
          gradientUnits="userSpaceOnUse"
          r="226.97"
        >
          <stop offset="0" stopColor="#373636" />
          <stop offset="0.0742" stopColor="#3e3e3d" />
          <stop offset="0.1777" stopColor="#515150" />
          <stop offset="0.2987" stopColor="#6e6e6d" />
          <stop offset="0.4317" stopColor="#939393" />
          <stop offset="0.4581" stopColor="#9b9b9a" />
          <stop offset="0.5564" stopColor="#b9b8b8" />
          <stop offset="0.6658" stopColor="#d2d2d2" />
          <stop offset="0.7569" stopColor="#e2e2e2" />
          <stop offset="0.8177" stopColor="#e7e7e7" />
          <stop offset="1" stopColor="#fff" />
        </radialGradient>
        <radialGradient
          id="gradient-29"
          cx="1528.5"
          cy="17073"
          gradientTransform="matrix(0.076091, 0, 0, 0.01845, 335.06354, -187.022354)"
          gradientUnits="userSpaceOnUse"
          r="226.97"
        >
          <stop offset="0" stopColor="#373636" />
          <stop offset="0.0742" stopColor="#3e3e3d" />
          <stop offset="0.1777" stopColor="#515150" />
          <stop offset="0.2987" stopColor="#6e6e6d" />
          <stop offset="0.4317" stopColor="#939393" />
          <stop offset="0.4581" stopColor="#9b9b9a" />
          <stop offset="0.5564" stopColor="#b9b8b8" />
          <stop offset="0.6658" stopColor="#d2d2d2" />
          <stop offset="0.7569" stopColor="#e2e2e2" />
          <stop offset="0.8177" stopColor="#e7e7e7" />
          <stop offset="1" stopColor="#fff" />
        </radialGradient>
      </defs>
      <g style={{}} transform="matrix(0.351445, 0, 0, 0.620311, -31.142496, -87.158348)">
        {/* <title>SolarPv</title> power*/}
        {pvPower > 0 ? (
          <AnimationPv
            variant={{
              initial: { x: -11 },
              animate: { x: 27 },
            }}
          />
        ) : (
          <AnimationPv
            variant={{
              initial: { x: -11 },
              animate: { x: -11 },
            }}
          />
        )}
        <path
          style={{}}
          d="M 199.826 239.851 C 199.826 241.412 179.191 242.682 153.739 242.682 C 128.284 242.682 107.65 241.412 107.65 239.851 C 107.65 238.29 128.284 237.018 153.739 237.018 C 179.191 237.018 199.826 238.29 199.826 239.851 Z"
          fill="url(#ai)"
        >
          {/* <title>panelShadow</title> */}
        </path>
        <path style={{}} d="M 148.165 206.831 L 161.362 206.831 L 161.362 239.322 L 148.165 239.322 Z" fill="url(#ae)">
          {/* <title>panelBase</title> */}
        </path>
        <path
          style={{}}
          d="M 93.442 219.628 L 93.442 223.536 C 93.442 224.209 94.144 224.757 95.01 224.757 L 214.519 224.757 C 215.384 224.757 216.085 224.209 216.085 223.536 L 216.085 219.628 L 93.443 219.628 Z"
          fill="url(#z)"
        >
          {/* <title>Path1</title> */}
        </path>
        <path
          style={{}}
          d="M 216.085 219.6 C 216.249 219.998 215.678 220.32 214.812 220.32 L 94.715 220.32 C 93.849 220.32 93.279 219.998 93.442 219.6 L 106.935 186.732 C 107.099 186.333 107.774 186.011 108.44 186.011 L 201.086 186.011 C 201.755 186.011 202.43 186.333 202.592 186.732 L 216.085 219.6 Z"
          fill="url(#t)"
        ></path>
        <path
          style={{ fill: 'rgb(226, 239, 245)' }}
          d="M 117.838 191.834 C 117.717 192.232 117.047 192.555 116.34 192.555 L 111.12 192.555 C 110.414 192.555 109.96 192.233 110.106 191.834 L 111.187 188.892 C 111.333 188.494 112.003 188.171 112.683 188.171 L 117.719 188.171 C 118.399 188.171 118.853 188.494 118.732 188.892 Z M 116.284 196.955 C 116.164 197.354 115.469 197.674 114.734 197.674 L 109.292 197.674 C 108.558 197.674 108.078 197.354 108.226 196.955 L 109.306 194.011 C 109.453 193.614 110.147 193.292 110.857 193.292 L 116.109 193.292 C 116.82 193.292 117.298 193.613 117.176 194.011 Z M 114.728 202.077 C 114.609 202.473 113.89 202.796 113.126 202.796 L 107.467 202.796 C 106.702 202.796 106.199 202.473 106.347 202.077 L 107.427 199.133 C 107.572 198.736 108.291 198.414 109.03 198.414 L 114.502 198.414 C 115.242 198.414 115.745 198.736 115.624 199.133 Z M 113.173 207.196 C 113.053 207.596 112.311 207.917 111.517 207.917 L 105.639 207.917 C 104.844 207.917 104.319 207.596 104.465 207.196 L 105.545 204.254 C 105.692 203.855 106.434 203.533 107.203 203.533 L 112.893 203.533 C 113.663 203.533 114.188 203.855 114.067 204.254 Z M 111.62 212.318 C 111.499 212.715 110.733 213.039 109.91 213.039 L 103.813 213.039 C 102.988 213.039 102.438 212.715 102.584 212.318 L 103.666 209.375 C 103.812 208.978 104.578 208.655 105.376 208.655 L 111.287 208.655 C 112.084 208.655 112.634 208.978 112.513 209.375 Z M 110.065 217.44 C 109.944 217.837 109.154 218.159 108.301 218.159 L 101.986 218.159 C 101.132 218.159 100.558 217.837 100.705 217.44 L 101.785 214.496 C 101.933 214.099 102.722 213.776 103.55 213.776 L 109.678 213.776 C 110.506 213.776 111.079 214.099 110.959 214.496 Z M 127.252 191.834 C 127.164 192.232 126.518 192.555 125.812 192.555 L 120.589 192.555 C 119.884 192.555 119.406 192.233 119.521 191.834 L 120.373 188.892 C 120.49 188.494 121.134 188.171 121.815 188.171 L 126.85 188.171 C 127.53 188.171 128.009 188.494 127.918 188.892 Z M 126.093 196.955 C 126.005 197.354 125.334 197.674 124.6 197.674 L 119.159 197.674 C 118.424 197.674 117.921 197.354 118.036 196.955 L 118.889 194.011 C 119.004 193.614 119.674 193.292 120.385 193.292 L 125.637 193.292 C 126.348 193.292 126.849 193.613 126.76 194.011 Z M 124.935 202.077 C 124.846 202.473 124.152 202.796 123.388 202.796 L 117.728 202.796 C 116.962 202.796 116.436 202.473 116.553 202.077 L 117.405 199.133 C 117.52 198.736 118.214 198.414 118.952 198.414 L 124.424 198.414 C 125.165 198.414 125.692 198.736 125.6 199.133 Z M 123.776 207.196 C 123.686 207.596 122.97 207.917 122.175 207.917 L 116.297 207.917 C 115.503 207.917 114.952 207.596 115.067 207.196 L 115.919 204.254 C 116.036 203.855 116.753 203.533 117.521 203.533 L 123.212 203.533 C 123.981 203.533 124.532 203.855 124.443 204.254 Z M 122.62 212.318 C 122.529 212.715 121.788 213.038 120.964 213.038 L 114.868 213.038 C 114.044 213.038 113.47 212.715 113.585 212.318 L 114.437 209.375 C 114.554 208.977 115.294 208.655 116.092 208.655 L 122.001 208.655 C 122.8 208.655 123.375 208.977 123.285 209.375 Z M 121.461 217.44 C 121.371 217.837 120.605 218.159 119.752 218.159 L 113.437 218.159 C 112.584 218.159 111.984 217.837 112.1 217.44 L 112.954 214.496 C 113.068 214.099 113.833 213.776 114.661 213.776 L 120.79 213.776 C 121.618 213.776 122.216 214.099 122.126 214.496 Z M 137.004 191.834 C 136.945 192.232 136.325 192.555 135.619 192.555 L 130.398 192.555 C 129.691 192.555 129.188 192.233 129.271 191.834 L 129.888 188.892 C 129.971 188.494 130.59 188.171 131.27 188.171 L 136.306 188.171 C 136.986 188.171 137.489 188.494 137.433 188.892 Z M 136.252 196.955 C 136.194 197.354 135.551 197.674 134.816 197.674 L 129.374 197.674 C 128.639 197.674 128.111 197.354 128.195 196.955 L 128.811 194.011 C 128.897 193.614 129.537 193.292 130.248 193.292 L 135.501 193.292 C 136.212 193.292 136.741 193.613 136.683 194.011 Z M 135.506 202.077 C 135.447 202.473 134.781 202.796 134.016 202.796 L 128.356 202.796 C 127.592 202.796 127.038 202.473 127.122 202.077 L 127.74 199.133 C 127.823 198.736 128.49 198.414 129.231 198.414 L 134.702 198.414 C 135.442 198.414 135.994 198.736 135.936 199.133 Z M 134.758 207.196 C 134.701 207.596 134.008 207.917 133.215 207.917 L 127.337 207.917 C 126.543 207.917 125.966 207.596 126.05 207.196 L 126.666 204.254 C 126.751 203.855 127.442 203.533 128.21 203.533 L 133.901 203.533 C 134.67 203.533 135.246 203.855 135.188 204.254 Z M 134.011 212.318 C 133.954 212.715 133.238 213.038 132.413 213.038 L 126.318 213.038 C 125.495 213.038 124.893 212.715 124.977 212.318 L 125.593 209.375 C 125.676 208.977 126.391 208.655 127.191 208.655 L 133.1 208.655 C 133.897 208.655 134.499 208.977 134.439 209.375 Z M 133.262 217.44 C 133.204 217.837 132.465 218.159 131.611 218.159 L 125.296 218.159 C 124.444 218.159 123.818 217.837 123.901 217.44 L 124.519 214.496 C 124.602 214.099 125.342 213.776 126.169 213.776 L 132.298 213.776 C 133.125 213.776 133.75 214.099 133.692 214.496 Z M 149.048 191.834 C 149.03 192.232 148.442 192.555 147.736 192.555 L 142.514 192.555 C 141.809 192.555 141.273 192.232 141.317 191.834 L 141.642 188.892 C 141.686 188.494 142.273 188.171 142.953 188.171 L 147.989 188.171 C 148.669 188.171 149.206 188.494 149.187 188.892 Z M 148.808 196.955 C 148.79 197.354 148.178 197.675 147.443 197.675 L 142.002 197.675 C 141.266 197.675 140.706 197.354 140.75 196.955 L 141.075 194.012 C 141.12 193.614 141.73 193.292 142.44 193.292 L 147.694 193.292 C 148.405 193.292 148.966 193.614 148.946 194.012 Z M 148.568 202.077 C 148.547 202.473 147.914 202.796 147.148 202.796 L 141.488 202.796 C 140.724 202.796 140.139 202.473 140.184 202.077 L 140.51 199.133 C 140.553 198.736 141.188 198.414 141.927 198.414 L 147.4 198.414 C 148.14 198.414 148.724 198.736 148.706 199.133 Z M 148.327 207.196 C 148.307 207.597 147.648 207.918 146.855 207.918 L 140.976 207.918 C 140.182 207.918 139.573 207.597 139.617 207.196 L 139.943 204.255 C 139.987 203.856 140.646 203.533 141.416 203.533 L 147.106 203.533 C 147.876 203.533 148.483 203.856 148.465 204.255 Z M 148.087 212.318 C 148.068 212.715 147.384 213.039 146.559 213.039 L 140.464 213.039 C 139.639 213.039 139.006 212.715 139.051 212.318 L 139.377 209.375 C 139.421 208.978 140.104 208.655 140.903 208.655 L 146.812 208.655 C 147.611 208.655 148.244 208.978 148.225 209.375 Z M 147.846 217.44 C 147.828 217.837 147.119 218.159 146.266 218.159 L 139.952 218.159 C 139.098 218.159 138.442 217.837 138.486 217.44 L 138.811 214.496 C 138.856 214.099 139.562 213.776 140.391 213.776 L 146.519 213.776 C 147.347 213.776 148.003 214.099 147.984 214.496 Z M 158.462 191.834 C 158.474 192.232 157.912 192.555 157.205 192.555 L 151.983 192.555 C 151.278 192.555 150.716 192.232 150.73 191.834 L 150.827 188.892 C 150.842 188.494 151.403 188.171 152.083 188.171 L 157.118 188.171 C 157.799 188.171 158.36 188.494 158.372 188.892 Z M 158.616 196.955 C 158.63 197.354 158.042 197.675 157.308 197.675 L 151.868 197.675 C 151.132 197.675 150.546 197.354 150.56 196.955 L 150.657 194.012 C 150.671 193.614 151.257 193.292 151.967 193.292 L 157.22 193.292 C 157.93 193.292 158.516 193.614 158.529 194.012 Z M 158.774 202.077 C 158.785 202.473 158.175 202.796 157.41 202.796 L 151.751 202.796 C 150.986 202.796 150.377 202.473 150.39 202.077 L 150.487 199.133 C 150.5 198.736 151.112 198.414 151.851 198.414 L 157.323 198.414 C 158.062 198.414 158.672 198.736 158.684 199.133 Z M 158.93 207.196 C 158.941 207.597 158.307 207.918 157.514 207.918 L 151.635 207.918 C 150.839 207.918 150.208 207.597 150.22 207.196 L 150.317 204.255 C 150.332 203.856 150.965 203.533 151.734 203.533 L 157.424 203.533 C 158.194 203.533 158.828 203.856 158.839 204.255 Z M 159.084 212.318 C 159.096 212.715 158.439 213.039 157.615 213.039 L 151.519 213.039 C 150.694 213.039 150.036 212.715 150.05 212.318 L 150.147 209.375 C 150.162 208.978 150.819 208.655 151.618 208.655 L 157.528 208.655 C 158.326 208.655 158.983 208.978 158.994 209.375 Z M 159.24 217.44 C 159.252 217.837 158.569 218.159 157.715 218.159 L 151.401 218.159 C 150.546 218.159 149.866 217.837 149.879 217.44 L 149.976 214.496 C 149.989 214.099 150.672 213.776 151.501 213.776 L 157.627 213.776 C 158.457 213.776 159.136 214.099 159.15 214.496 Z M 168.212 191.834 C 168.255 192.232 167.719 192.555 167.013 192.555 L 161.792 192.555 C 161.085 192.555 160.498 192.232 160.479 191.834 L 160.341 188.892 C 160.321 188.494 160.858 188.171 161.538 188.171 L 166.574 188.171 C 167.255 188.171 167.842 188.494 167.886 188.892 Z M 168.778 196.955 C 168.822 197.354 168.262 197.675 167.524 197.675 L 162.085 197.675 C 161.349 197.675 160.739 197.354 160.72 196.955 L 160.582 194.012 C 160.563 193.614 161.122 193.292 161.834 193.292 L 167.087 193.292 C 167.797 193.292 168.408 193.614 168.452 194.012 Z M 169.342 202.077 C 169.388 202.473 168.804 202.796 168.038 202.796 L 162.379 202.796 C 161.614 202.796 160.979 202.473 160.961 202.077 L 160.821 199.133 C 160.803 198.736 161.389 198.414 162.128 198.414 L 167.599 198.414 C 168.339 198.414 168.974 198.736 169.019 199.133 Z M 169.91 207.196 C 169.953 207.597 169.346 207.918 168.551 207.918 L 162.673 207.918 C 161.879 207.918 161.221 207.597 161.202 207.196 L 161.062 204.255 C 161.044 203.856 161.652 203.533 162.42 203.533 L 168.113 203.533 C 168.881 203.533 169.541 203.856 169.585 204.255 Z M 170.477 212.318 C 170.52 212.715 169.889 213.039 169.064 213.039 L 162.967 213.039 C 162.144 213.039 161.46 212.715 161.442 212.318 L 161.303 209.375 C 161.283 208.978 161.917 208.655 162.715 208.655 L 168.626 208.655 C 169.423 208.655 170.107 208.978 170.15 209.375 Z M 171.044 217.44 C 171.088 217.837 170.432 218.159 169.577 218.159 L 163.263 218.159 C 162.408 218.159 161.702 217.837 161.683 217.44 L 161.544 214.496 C 161.526 214.099 162.183 213.776 163.011 213.776 L 169.139 213.776 C 169.967 213.776 170.675 214.099 170.717 214.496 Z M 180.258 191.834 C 180.341 192.232 179.837 192.555 179.131 192.555 L 173.91 192.555 C 173.203 192.555 172.584 192.233 172.527 191.834 L 172.095 188.892 C 172.039 188.494 172.543 188.171 173.225 188.171 L 178.259 188.171 C 178.938 188.171 179.557 188.494 179.642 188.892 Z M 181.33 196.955 C 181.414 197.354 180.886 197.674 180.15 197.674 L 174.71 197.674 C 173.974 197.674 173.331 197.354 173.273 196.955 L 172.844 194.011 C 172.784 193.614 173.314 193.292 174.023 193.292 L 179.276 193.292 C 179.987 193.292 180.63 193.613 180.713 194.011 Z M 182.404 202.077 C 182.488 202.473 181.936 202.796 181.17 202.796 L 175.511 202.796 C 174.747 202.796 174.079 202.473 174.022 202.077 L 173.592 199.133 C 173.534 198.736 174.086 198.414 174.826 198.414 L 180.298 198.414 C 181.038 198.414 181.705 198.736 181.788 199.133 Z M 183.48 207.196 C 183.563 207.596 182.987 207.917 182.192 207.917 L 176.314 207.917 C 175.519 207.917 174.828 207.596 174.77 207.196 L 174.34 204.254 C 174.281 203.855 174.859 203.533 175.627 203.533 L 181.318 203.533 C 182.086 203.533 182.778 203.855 182.862 204.254 Z M 184.551 212.318 C 184.635 212.715 184.035 213.038 183.21 213.038 L 177.115 213.038 C 176.29 213.038 175.575 212.715 175.517 212.318 L 175.087 209.375 C 175.029 208.977 175.629 208.655 176.428 208.655 L 182.337 208.655 C 183.137 208.655 183.851 208.977 183.934 209.375 Z M 185.625 217.44 C 185.707 217.837 185.084 218.159 184.231 218.159 L 177.915 218.159 C 177.061 218.159 176.323 217.837 176.264 217.44 L 175.833 214.496 C 175.776 214.099 176.401 213.776 177.228 213.776 L 183.357 213.776 C 184.186 213.776 184.924 214.099 185.007 214.496 Z M 189.672 191.834 C 189.784 192.232 189.305 192.555 188.599 192.555 L 183.378 192.555 C 182.672 192.555 182.027 192.233 181.939 191.834 L 181.28 188.892 C 181.193 188.494 181.672 188.171 182.351 188.171 L 187.386 188.171 C 188.067 188.171 188.711 188.494 188.826 188.892 Z M 191.14 196.955 C 191.255 197.354 190.752 197.674 190.016 197.674 L 184.574 197.674 C 183.839 197.674 183.171 197.354 183.082 196.955 L 182.426 194.011 C 182.336 193.614 182.839 193.292 183.549 193.292 L 188.803 193.292 C 189.512 193.292 190.182 193.613 190.295 194.011 Z M 192.61 202.077 C 192.725 202.473 192.199 202.796 191.432 202.796 L 185.774 202.796 C 185.008 202.796 184.316 202.473 184.228 202.077 L 183.57 199.133 C 183.482 198.736 184.01 198.414 184.749 198.414 L 190.219 198.414 C 190.961 198.414 191.652 198.736 191.765 199.133 Z M 194.081 207.196 C 194.194 207.596 193.642 207.917 192.848 207.917 L 186.97 207.917 C 186.175 207.917 185.46 207.596 185.371 207.196 L 184.712 204.254 C 184.624 203.855 185.175 203.533 185.946 203.533 L 191.637 203.533 C 192.404 203.533 193.121 203.855 193.236 204.254 Z M 195.551 212.318 C 195.664 212.715 195.088 213.038 194.266 213.038 L 188.169 213.038 C 187.344 213.038 186.606 212.715 186.516 212.318 L 185.859 209.375 C 185.77 208.977 186.345 208.655 187.142 208.655 L 193.053 208.655 C 193.851 208.655 194.593 208.977 194.706 209.375 Z M 197.022 217.44 C 197.135 217.837 196.535 218.159 195.682 218.159 L 189.366 218.159 C 188.513 218.159 187.748 217.837 187.659 217.44 L 187.003 214.496 C 186.914 214.099 187.512 213.776 188.342 213.776 L 194.471 213.776 C 195.299 213.776 196.063 214.099 196.176 214.496 Z M 199.421 191.834 C 199.568 192.232 199.111 192.555 198.407 192.555 L 193.185 192.555 C 192.481 192.555 191.81 192.232 191.689 191.834 L 190.794 188.892 C 190.674 188.494 191.128 188.171 191.808 188.171 L 196.843 188.171 C 197.524 188.171 198.195 188.494 198.34 188.892 Z M 201.301 196.955 C 201.447 197.354 200.969 197.674 200.234 197.674 L 194.793 197.674 C 194.058 197.674 193.361 197.354 193.242 196.955 L 192.349 194.011 C 192.228 193.614 192.704 193.292 193.416 193.292 L 198.669 193.292 C 199.379 193.292 200.075 193.613 200.22 194.011 Z M 203.18 202.077 C 203.327 202.473 202.826 202.796 202.061 202.796 L 196.401 202.796 C 195.637 202.796 194.919 202.473 194.797 202.077 L 193.906 199.133 C 193.785 198.736 194.284 198.414 195.026 198.414 L 200.498 198.414 C 201.237 198.414 201.956 198.736 202.1 199.133 Z M 205.063 207.196 C 205.208 207.596 204.683 207.917 203.888 207.917 L 198.012 207.917 C 197.216 207.917 196.475 207.596 196.355 207.196 L 195.459 204.254 C 195.338 203.855 195.865 203.533 196.634 203.533 L 202.325 203.533 C 203.093 203.533 203.835 203.855 203.982 204.254 Z M 206.945 212.318 C 207.09 212.715 206.541 213.038 205.716 213.038 L 199.621 213.038 C 198.795 213.038 198.029 212.715 197.908 212.318 L 197.016 209.375 C 196.895 208.977 197.445 208.655 198.244 208.655 L 204.151 208.655 C 204.95 208.655 205.716 208.977 205.862 209.375 Z M 208.823 217.44 C 208.968 217.837 208.396 218.159 207.541 218.159 L 201.228 218.159 C 200.375 218.159 199.585 217.837 199.464 217.44 L 198.57 214.496 C 198.45 214.099 199.023 213.776 199.85 213.776 L 205.979 213.776 C 206.806 213.776 207.597 214.099 207.742 214.496 Z"
        ></path>
      </g>
      <g transform="matrix(1, 0, 0, 1, -105.498367, -3.132431)">
        {pylonPower === 0 ? (
          <AnimationPylon variant={{ initial: { x: -2, repeat: 0 }, animate: { x: -2 } }} />
        ) : pylonPower > 0 ? (
          <AnimationPylon
            variant={{
              initial: { x: -2, repeat: Infinity },
              animate: { x: -16 },
            }}
          />
        ) : (
          <AnimationPylon
            variant={{
              initial: { x: -2, repeat: Infinity },
              animate: { x: 13 },
            }}
          />
        )}

        <g style={{}} fillRule="evenodd" strokeWidth="0" transform="matrix(0.165531, 0, 0, 0.085854, 341.646606, 20.5889)">
          <rect height="60" style={{ fill: 'white' }} width="100.773" transform="matrix(-1, 0, 0, 1, 0, 0)" x="-400.8" y="220.374" />
        </g>
        <g transform="matrix(1.175902, 0, 0, 0.561832, -146.018982, -9.797303)">
          {/* <title>Tower</title> */}

          <path
            style={{}}
            d="M 468.646 127.954 C 468.646 130.263 460.91 132.139 451.37 132.139 C 441.828 132.139 434.092 130.263 434.092 127.954 C 434.092 125.645 441.828 123.767 451.37 123.767 C 460.91 123.767 468.646 125.645 468.646 127.954 Z"
            fill="url(#gradient-29)"
          >
            {/* <title>electricPylonShadow</title> */}
          </path>
          <path
            style={{ fill: '#c5c5c5' }}
            d="M 464.338 123.109 C 464.4 124.048 464.207 124.956 463.795 125.636 C 463.386 126.317 462.801 126.706 462.195 126.706 L 440.564 126.706 C 439.956 126.706 439.374 126.316 438.962 125.636 C 438.551 124.956 438.356 124.048 438.421 123.109 L 438.638 120.224 L 439.545 107.26 L 444.91 32.367 C 445.019 30.747 445.948 29.482 447.053 29.482 L 455.705 29.482 C 456.808 29.482 457.741 30.747 457.847 32.367 L 463.211 107.26 L 464.12 120.224 L 464.338 123.109 Z"
            // transform="scale(1,2)"
          />
          <path
            style={{ fill: 'rgb(148, 148, 148)' }}
            d="M 434.691 50.353 L 434.691 47.228 C 434.691 46.93 435.397 46.67 436.435 46.539 L 436.435 44.281 C 435.397 44.149 434.692 43.89 434.692 43.592 L 434.692 40.467 C 434.692 40.169 435.397 39.91 436.435 39.778 L 436.435 37.362 C 436.435 35.096 437.129 33.259 437.988 33.259 C 438.846 33.259 439.54 35.096 439.54 37.362 L 439.54 39.778 C 440.578 39.909 441.284 40.169 441.284 40.467 L 441.284 43.592 C 441.284 43.89 440.578 44.15 439.54 44.281 L 439.54 46.539 C 440.578 46.67 441.283 46.93 441.283 47.228 L 441.283 50.353 C 441.283 50.651 440.578 50.911 439.54 51.042 L 439.54 53.774 C 439.54 56.04 438.846 57.877 437.988 57.877 C 437.129 57.877 436.435 56.04 436.435 53.774 L 436.435 51.042 C 435.397 50.911 434.691 50.651 434.691 50.353 Z"
          />
          <path
            style={{ fill: 'rgb(148, 148, 148)' }}
            d="M 464.83 57.877 C 463.971 57.877 463.277 56.04 463.277 53.774 L 463.277 51.042 C 462.239 50.911 461.533 50.651 461.533 50.353 L 461.533 47.228 C 461.533 46.93 462.239 46.67 463.277 46.539 L 463.277 44.281 C 462.239 44.149 461.534 43.89 461.534 43.592 L 461.534 40.467 C 461.534 40.169 462.239 39.91 463.277 39.778 L 463.277 37.362 C 463.277 35.096 463.971 33.259 464.83 33.259 C 465.688 33.259 466.382 35.096 466.382 37.362 L 466.382 39.778 C 467.42 39.909 468.126 40.169 468.126 40.467 L 468.126 43.592 C 468.126 43.89 467.42 44.15 466.382 44.281 L 466.382 46.539 C 467.42 46.67 468.125 46.93 468.125 47.228 L 468.125 50.353 C 468.125 50.651 467.42 50.911 466.382 51.042 L 466.382 53.774 C 466.382 56.04 465.688 57.877 464.83 57.877 Z"
          />
          <path
            style={{}}
            d="M 467.131 26.296 L 467.122 30.945 C 467.121 31.674 466.77 32.308 466.283 32.464 L 451.447 37.113 C 451.374 37.129 451.3 37.144 451.225 37.144 C 451.151 37.144 451.078 37.129 451.003 37.113 L 436.185 32.464 C 435.696 32.308 435.349 31.674 435.35 30.945 L 435.358 26.296 C 435.359 25.443 435.837 24.746 436.42 24.746 L 466.073 24.746 C 466.655 24.746 467.131 25.443 467.131 26.296 Z"
            fill="url(#z)"
            transform="matrix(-1, 0.001001, -0.000539, -1, 902.49756, 61.438301)"
          />
        </g>
      </g>

      <g style={{}} transform="matrix(0.657297, 0, 0, 0.746515, -3.712922, -179.704086)">
        {/* <title>House</title> */}
        {housePower > 0 ? (
          <AnimationHouse
            variant={{
              initial: { y: -1 },
              animate: { y: 12 },
            }}
          />
        ) : (
          <AnimationHouse
            variant={{
              initial: { y: -1 },
              animate: { y: -1 },
            }}
          />
        )}

        <path
          style={{ fill: 'rgb(255, 255, 255)' }}
          d="M 255.589 364.686 L 330.33 430.867 L 179.807 435.108 L 255.589 364.686 Z"
          transform="matrix(0.999529, 0.02701, -0.03484, 0.999529, 14.053126, -6.644972)"
        />
        <path
          style={{}}
          d="M 156.915 432.413 L 179.939 432.413 L 256.689 365.557 L 345.705 447.882 L 256.689 361.095 L 233.664 361.095 Z"
          fill="url(#gradient-2)"
        />
        <path
          style={{}}
          d="M 281.107 383.788 L 272.25 375.282 L 287.387 375.282 L 335.11 420.34 L 287.11 378.767 Z"
          fill="url(#gradient-2)"
        />
        <path
          style={{}}
          d="M 255.591 400.636 L 255.591 414.491 L 244.422 414.491 L 244.422 400.636 Z M 269.132 400.636 L 269.132 414.491 L 257.963 414.491 L 257.963 400.636 Z M 255.596 416.763 L 255.596 430.619 L 244.427 430.619 L 244.427 416.763 Z M 269.195 416.68 L 269.195 430.536 L 258.026 430.536 L 258.026 416.68 Z"
          fill="#888a85"
        />
      </g>
      <g style={{}} transform="matrix(0.623871, 0, 0, 0.78335, -1.674215, -8.366261)">
        {/* <title>SmartVive</title> */}
        <rect
          height="74.654"
          style={{ stroke: 'rgb(0, 0, 0)', strokeWidth: '1.94395px', fill: props.color }}
          width="157.707"
          x="181.044"
          y="15.397"
        />
        {/* <rect height="27.557" style={{ stroke: 'black', strokeWidth: '0.485987px', fill: 'white' }} width="77.805" x="182.009" y="31.675" /> */}
        {/* <rect height="27.557" style={{ stroke: 'black', strokeWidth: '0.485987px', fill: 'white' }} width="77.937" x="259.965" y="31.675" /> */}
        <rect height="56" style={{ fill: 'rgb(255, 255, 255)' }} width="155.631" x="182.108" y="33" />
        <text
          style={{ fill: 'rgb(230, 244, 249)', fontFamily: '&quot', fontSize: '28px', textAnchor: 'middle', whiteSpace: 'pre' }}
          transform="matrix(0.667291, 0, 0, 0.506171, 161.902344, 9.544089)"
          x="147.318"
          y="38.585"
        >
          {/* {props.name} */}
        </text>

        {/* <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '6.5px',
            lineHeight: '30px',
            whiteSpace: 'pre',
          }}
          x="184"
          y="40"
        >
          {translate('smartmanagerApp.convElectricPv.energyExported')}
        </text> */}
        {/* <text
          style={{ fill: 'rgb(51, 51, 51)', fontWeight: 'bold', fontSize: '13px', lineHeight: '30px', whiteSpace: 'pre' }}
          x="184"
          y="58"
        >
          {props.pvEnergyImported}kWh
        </text>
        <text
          style={{ fill: 'rgb(51, 51, 51)', fontSize: '6.5px', lineHeight: '30px', textAnchor: 'end', whiteSpace: 'pre' }}
          x="336"
          y="40"
        >
          {translate('smartmanagerApp.convElectricPv.energyImported')}
        </text> */}
        {/* <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontWeight: 'bold',
            fontSize: '13px',
            lineHeight: '30px',
            textAnchor: 'end',
            whiteSpace: 'pre',
          }}
          x="336"
          y="58"
        >
          {props.pylonEnergyImported}kWh
        </text> */}
        {/* <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '6.5px',
            lineHeight: '30px',
            whiteSpace: 'pre',
            textAnchor: 'middle',
          }}
          x="260"
          y="70"
        >
          {translate('smartmanagerApp.convElectricPv.totalConsume')}
        </text> */}
        {/* <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '30px',
            whiteSpace: 'pre',
            textAnchor: 'middle',
          }}
          x="260"
          y="84"
        >
          {props.houseConsume}kWh
        </text> */}
      </g>
      <g>
        {/* <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '7px',
            lineHeight: '30px',
            textAnchor: 'middle',
            whiteSpace: 'pre',
          }}
          x="75"
          y="28"
        >
          {translate('smartmanagerApp.convElectricPv.power')}:
        </text> */}

        <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '7px',
            lineHeight: '30px',
            textAnchor: 'middle',
            whiteSpace: 'pre',
          }}
          x="75"
          y="35"
        >
          {decimalFormat(pvPower > 0 ? pvPower : 0, 2) + 'kW'}
        </text>

        {/* <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '7px',
            lineHeight: '30px',
            textAnchor: 'middle',
            whiteSpace: 'pre',
          }}
          x="245"
          y="28"
        >
          {translate('smartmanagerApp.convElectricPv.power')}:
        </text> */}

        <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '7px',
            lineHeight: '30px',
            textAnchor: 'middle',
            whiteSpace: 'pre',
          }}
          x="245"
          y="35"
        >
          {decimalFormat(pylonPower, 2) + 'kW'}
        </text>
        {/* 
        <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '7px',
            lineHeight: '30px',
            textAnchor: 'start',
            whiteSpace: 'pre',
          }}
          x="165"
          y="75"
        >
          {translate('smartmanagerApp.convElectricPv.power')}:
        </text> */}

        <text
          style={{
            fill: 'rgb(51, 51, 51)',
            fontFamily: '&quot',
            fontSize: '7px',
            lineHeight: '30px',
            textAnchor: 'start',
            whiteSpace: 'pre',
          }}
          x="165"
          y="82"
        >
          {decimalFormat(housePower, 2) + 'kW'}
        </text>
      </g>
      <image width={550} height={550} transform="matrix(.08109 0 0 .0818 136.193 20.213)" href="api/app-settings/short-logo" />
    </svg>
  );
};
